import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as MoneyBag } from '@pkg/assets/icons/v2/crypto-money-bag.svg';
import { DepButton, DepButtonDisplay } from '@pkg/components/deprecated';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';
import { type CryptoType } from '@pkg/types';

import { apiFactory } from '@app/client';
import { Cart } from '@app/client/resources';
import { setReduxCartItems } from '@app/store/actions/picker';

interface CryptoStepNotEnoughProps {
    cryptoType: CryptoType;
    onBack: () => void;
}

export const CryptoStepNotEnough = ({ onBack, cryptoType }: CryptoStepNotEnoughProps) => {
    const { t } = useTranslation(['yat_picker']);
    const { salesAmount } = useAppSelector((rootState) => rootState.crypto);
    const dispatch = useAppDispatch();

    const handleBack = async () => {
        const res = await apiFactory().call(Cart.convertToDraft, {});
        if (res.ok) {
            dispatch(setReduxCartItems(res.value));
        }
        onBack();
    };

    return (
        <div className="yat-picker-checkout__sidebar-vertical">
            <div className="yat-picker-checkout__sidebar-moneybag">
                <MoneyBag />
            </div>
            <h2 className="yat-picker-checkout__sidebar-cryptotitle status">{t('pay_crypto_not_enough_title')}</h2>
            <p
                className="yat-picker-checkout__sidebar-cryptoinstruct"
                dangerouslySetInnerHTML={{
                    __html: t('pay_crypto_not_enough_instruction', {
                        amount: salesAmount.amount,
                        actualAmount: salesAmount.actualAmount,
                        unit: cryptoType,
                    }),
                }}
            />
            <div>
                <DepButton display={DepButtonDisplay.block} onClick={handleBack}>
                    {t('crypto_try_again_cta')}
                </DepButton>
            </div>
        </div>
    );
};
